import { useSyncExternalStore } from "react";
import { session } from "@/shared/api/session";

/** Current login state of this tab; re-renders when the user logs in or out. */
export function useSession() {
  return useSyncExternalStore(session.subscribe, session.getState);
}
